let isVariantsHidden = false;

function hideUnavailableVariantsProductCard() {
  if (isVariantsHidden) return; // Выход, если уже скрыто

  // Извлекаем все карточки продуктов
  const productCards = document.querySelectorAll('.product-card');

  let userGeolocation = localStorage.getItem('userGeolocation');

  productCards.forEach((productCard) => {
    // Извлекаем мета-поля внутри каждой карточки
    const usMetaItems = productCard.querySelectorAll('.meta-hide-logic-us__item');
    const restMetaItems = productCard.querySelectorAll('.meta-hide-logic-rest__item');

    // Находим все fieldset внутри карточки
    const fieldsets = productCard.querySelectorAll('.product-card-swatches .product-card-swatch');

    // Если нет fieldsets, повторим через 4 секунды
    if (!fieldsets || !fieldsets.length) {
      setTimeout(() => hideUnavailableVariantsProductCard(), 4000);
      return;
    }

    fieldsets.forEach((fieldset) => {

      // Логика для США
      usMetaItems.forEach((metaItem) => {
        const shouldHideUS = metaItem.querySelector('#meta-hide-logic-us-data')?.textContent === 'true';
        const variantNameUS = metaItem.querySelector('#meta-hide-logic-us-variant-name')?.textContent;

        if (shouldHideUS && userGeolocation === 'US') {
          hideVariant(fieldset, variantNameUS);
        }
      });

      // Логика для остальных стран
      restMetaItems.forEach((metaItem) => {
        const shouldHideRest = metaItem.querySelector('#meta-hide-logic-rest-data')?.textContent === 'true';
        const variantNameRest = metaItem.querySelector('#meta-hide-logic-rest-variant-name')?.textContent;

        if (shouldHideRest && userGeolocation !== 'US') {
          hideVariant(fieldset, variantNameRest);
        }
      });
    });
  });

  // Устанавливаем флаг, чтобы предотвратить повторные вызовы
  isVariantsHidden = true;
}

// скрыть нужные переключатели
function hideVariant(fieldset, variantName) {
  // Находим все span внутри fieldset
  const spans = fieldset.querySelectorAll('span');

  spans.forEach((span) => {
    // Проверяем, содержится ли название варианта внутри текста span
    if (span.textContent.trim() === variantName) {

      // Скрываем сам span
      span.style.display = 'none';

      // Находим ближайший div (родителя или с классом)
      const parentDiv = span.closest('div');
      if (parentDiv) {
        parentDiv.style.display = 'none';
      }
    }
  });
}

hideUnavailableVariantsProductCard();